import { FileDown, Printer } from "lucide-react";

const SPECS = "85 × 55 mm · 300 DPI · 3 mm di abbondanza inclusa";

export const PrintKit = () => (
    <div className="flex flex-col gap-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="card-frame overflow-hidden rounded-xl" data-testid="print-preview-front">
                <img src="/assets/biglietto-fronte.png" alt="Biglietto da visita — fronte" className="w-full" />
                <p className="font-code border-t border-[rgba(226,192,117,0.16)] bg-[#121418] py-2.5 text-center text-[9px] uppercase tracking-[0.3em] text-[#a1a8b3]">
                    Fronte
                </p>
            </div>
            <div className="card-frame overflow-hidden rounded-xl" data-testid="print-preview-back">
                <img src="/assets/biglietto-retro.png" alt="Biglietto da visita — retro" className="w-full" />
                <p className="font-code border-t border-[rgba(226,192,117,0.16)] bg-[#121418] py-2.5 text-center text-[9px] uppercase tracking-[0.3em] text-[#a1a8b3]">
                    Retro
                </p>
            </div>
        </div>
        <p className="font-code text-center text-[10px] uppercase tracking-[0.25em] text-[#686f7c]" data-testid="print-specs">
            {SPECS}
        </p>
        <a
            data-testid="print-pdf-download-button"
            href="/assets/biglietto-minocesari-print.pdf"
            download="biglietto-minocesari-stampa.pdf"
            className="group relative flex items-center justify-center gap-3 overflow-hidden rounded-xl bg-[#e2c075] px-6 py-4 transition-transform duration-300 active:scale-[0.98]"
        >
            <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
            <Printer className="h-4 w-4 shrink-0 text-[#090a0c]" />
            <span className="font-code whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.18em] text-[#090a0c]">
                Scarica il PDF per la tipografia
            </span>
        </a>
        <div className="flex flex-col gap-3 sm:flex-row">
            <a
                data-testid="print-front-download-button"
                href="/assets/biglietto-fronte.png"
                download="biglietto-minocesari-fronte.png"
                className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-[rgba(226,192,117,0.3)] px-5 py-3.5 text-[#e2c075] transition-colors duration-300 hover:bg-[rgba(226,192,117,0.06)]"
            >
                <FileDown className="h-4 w-4" />
                <span className="font-code text-[11px] uppercase tracking-[0.2em]">Fronte PNG</span>
            </a>
            <a
                data-testid="print-back-download-button"
                href="/assets/biglietto-retro.png"
                download="biglietto-minocesari-retro.png"
                className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-[rgba(226,192,117,0.3)] px-5 py-3.5 text-[#e2c075] transition-colors duration-300 hover:bg-[rgba(226,192,117,0.06)]"
            >
                <FileDown className="h-4 w-4" />
                <span className="font-code text-[11px] uppercase tracking-[0.2em]">Retro PNG</span>
            </a>
        </div>
    </div>
);
